<template>
  <div class="sidebar-box mt-6 p-1">
    <h6 class="mb-3 p-2" v-b-toggle.feature-filter>
      ویژگی ها
      <b-icon icon="arrow-down-circle"></b-icon>
    </h6>

    <b-collapse id="feature-filter" class="p-2">
      <div class="form-group form-check" v-for="feature in features">
        <input v-model="selectedFeature" :value="feature.id" name="filter_features"
               type="checkbox"
               class="form-check-input" :id="`feature_filter_${feature.id}`">
        <label class="form-check-label mr-3" :for="`feature_filter_${feature.id}`">{{ feature.feature.public_name }} {{ feature.value }}</label>
      </div>
    </b-collapse>


  </div>
</template>

<script>
export default {
  name: "Feature1",
  data() {
    return {
      features: [],
      selectedFeature: []
    }
  },
  async mounted() {
    this.features = await this.$store.dispatch('Feature/searchFeature')
    this.features = this.features.data.data
  },
  watch: {
    selectedFeature: {
      handler() {
        this.$emit('features', this.selectedFeature)
      }
    }
  }
}
</script>

<style scoped>

.sidebar-box {
  border-radius: 10px;
  background: white;
  box-shadow: 0px 5px 25px rgba(218, 211, 211, 0.3);
  margin-bottom: 30px;
  border: 1px solid #F5F4F4;
}

</style>